import { getProjectAndSummaryReports } from '../../../../../api/projectApi';
import { generatePdfOnePagerProjectReport } from '../Generators/OnePagerProjectReportGenerator';

export const downloadOnePagerReport = async (currentProject, setIsLoading) => {
  if (!currentProject) return;

  const reportData = await getProjectAndSummaryReports(currentProject);

  if (!reportData) {
    console.error('No data received from getProjectAndSummaryReports, aborting PDF generation.');
    return;
  }

  await generatePdfOnePagerProjectReport({ data: reportData, onLoading: setIsLoading });
};